import React from "react";
import PropTypes from "prop-types";
import classes from "./chooseRiver.module.scss";
import { useSelector } from "react-redux";
import { onChangeForm } from "../../../../../store/actions/home.js";
import SelectInput from "../../../../UI/selectInput/selectInput.js";

const ChooseRiver = (props) => {
  const classModifier = props.classModifier
    ? classes[props.classModifier]
    : null;
  const form = useSelector((state) => state.home.form);
  return (
    <div className={`${classes.form__wrapper} ${classModifier}`}>
      <form className={classes.form}>
        <h2 className={classes.form__title}>Пошук річки:</h2>
        {Object.keys(form).map((key, i) => (
          <SelectInput
            classModifier={props.classModifier}
            form={form}
            onChange={onChangeForm}
            key={i}
            disabled={form[key].disabled}
            name={form[key].name}
            placeholder={form[key].placeholder}
            options={form[key].options}
          />
        ))}
      </form>
    </div>
  );
};

ChooseRiver.propTypes = {
  //products: PropTypes.array
};

export default ChooseRiver;
